import { createSelector } from 'reselect';
import {
  makeNullSafeDomainGetter,
  mortgageOfficeByIdSelector,
} from './common';

const mortgageOfficesSelector = makeNullSafeDomainGetter(mortgageOfficeByIdSelector, 'getPublicMortgageAdvisorsOfficesByIds');
export const mortgageOfficeSelector = createSelector([ mortgageOfficesSelector ], list => list && list.offices && list.offices.length ? list.offices[0] : null);
